import axios from 'axios';
import type { IStringifyOptions } from 'qs';
import qs from 'qs';

const serializeConfig: IStringifyOptions = {
  arrayFormat: 'comma',
  skipNulls: true,
  filter: (_prefix, value) => {
    if (Array.isArray(value)) {
      return value?.length ? value.toSorted((a, b) => `${a}`.localeCompare(`${b}`)) : undefined;
    }

    return !!value || value === 0 ? value : undefined;
  },
  sort: (a, b) => a.localeCompare(b),
};
export const paramsSerializer = (params: Record<string, any>) => qs.stringify(params, serializeConfig);
const uefaAxios = axios.create({
  paramsSerializer,
});

export default uefaAxios;
